import { render, staticRenderFns } from "./style-test.vue?vue&type=template&id=b8349b4e&scoped=true&"
import script from "./style-test.vue?vue&type=script&lang=js&"
export * from "./style-test.vue?vue&type=script&lang=js&"
import style0 from "./style-test.vue?vue&type=style&index=0&id=b8349b4e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8349b4e",
  null
  
)

export default component.exports